import { Component, Output, EventEmitter} from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-final-cta',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './final-cta.component.html',
  styleUrl: './final-cta.component.scss'
})
export class FinalCtaComponent {
   @Output() openDemoPopupEvent = new EventEmitter<void>();
}

